(() => {
  document.querySelectorAll('[data-rb-legal-preferences]').forEach((button) => {
    if (button.dataset.rbBound) return;
    button.dataset.rbBound = 'true';
    button.addEventListener('click', async () => {
      const status = button.closest('.rb-legal-footer').querySelector('[data-rb-legal-status]');
      status.textContent = '';
      try {
        if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Preferences unavailable');
        await window.privacyBanner.showPreferences();
      } catch {
        status.textContent = status.dataset.error;
      }
    });
  });
})();
